var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_386_1103)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 11,
    r: 11,
    fill: "#51CDA0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6173 7.38657H18.0181L17.2318 6.20734C17.1896 6.14419 17.1326 6.09242 17.0657 6.05659C16.9987 6.02077 16.924 6.002 16.8481 6.00195H13.1558C13.0799 6.002 13.0052 6.02077 12.9382 6.05659C12.8713 6.09242 12.8143 6.14419 12.7721 6.20734L11.9852 7.38657H10.3866C10.0193 7.38657 9.66716 7.53245 9.4075 7.79212C9.14783 8.05178 9.00195 8.40396 9.00195 8.77119V15.2327C9.00195 15.6 9.14783 15.9521 9.4075 16.2118C9.66716 16.4715 10.0193 16.6174 10.3866 16.6174H19.6173C19.9846 16.6174 20.3367 16.4715 20.5964 16.2118C20.8561 15.9521 21.002 15.6 21.002 15.2327V8.77119C21.002 8.40396 20.8561 8.05178 20.5964 7.79212C20.3367 7.53245 19.9846 7.38657 19.6173 7.38657ZM17.0789 11.7712C17.0789 12.182 16.9571 12.5835 16.7289 12.9251C16.5006 13.2666 16.1763 13.5328 15.7968 13.69C15.4172 13.8472 14.9997 13.8883 14.5968 13.8082C14.1939 13.7281 13.8238 13.5303 13.5333 13.2398C13.2429 12.9493 13.0451 12.5793 12.9649 12.1764C12.8848 11.7735 12.9259 11.3559 13.0831 10.9764C13.2403 10.5969 13.5065 10.2725 13.8481 10.0443C14.1896 9.81608 14.5912 9.69427 15.002 9.69427C15.5528 9.69427 16.0811 9.91308 16.4706 10.3026C16.8601 10.6921 17.0789 11.2204 17.0789 11.7712Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_386_1103",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_386_1103"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_386_1103",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.911645279a1989d2283cbbe483439c88.svg";
export { ForwardRef as ReactComponent };